import { keycloak } from '@/globals/helpers/keycloak-init';

export default {
  namespaced: true,
  state: {
    user: {
      isSet: false,
      firstName: '',
      lastName: '',
      fullName: '',
      sub: '',
      roles: [],
      groups: [],
      email: '',
    },
  },
  mutations: {
    setUserFromKeycloak(state, payload) {
      // ignore eslint as it doesnt like underscored variables
      /* eslint-disable */
      const { given_name, family_name, name, preferred_username, groups, sub, email } = payload;
      state.user.firstName = given_name;
      state.user.lastName = family_name;
      state.user.sub = sub;
      state.user.fullName = name;
      state.user.username = preferred_username;
      state.user.roles = groups;
      state.user.groups = groups.filter(group => group.name !== 'otherRoles')
        .sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      state.user.email = email;

      state.user.isSet = true;
      /* eslint-enable */
    },
  },
  actions: {
    logout() {
      localStorage.removeItem('vue-refresh-token');
      localStorage.removeItem('uma-token');
      keycloak.logout();
    },
  },
};
